import {
  Button,
  Center,
  Group,
  Input,
  Loader,
  Modal,
  Text,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import EventsTable from "Components/Admin/AdminOtherDetails/AdminEvents/EventsTable";
import { Search } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useBulkDeleteEventsMutation,
  useDeleteEventMutation,
  useGetAllEventsQuery,
} from "Services/EventApiSlice";
import { AdminEvent } from "Types/Admin/AdminEventType";

const AdminEvents: React.FC = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [selectedEventIds, setSelectedEventIds] = useState<number[]>([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);
  const plant = process.env.REACT_APP_PLANT;

  const {
    data: events = [],
    isLoading,
    refetch,
  } = useGetAllEventsQuery({
    plant,
    search: search || undefined,
  });

  const [deleteEvent] = useDeleteEventMutation();
  const [bulkDeleteEvents] = useBulkDeleteEventsMutation();

  const handleView = (item: AdminEvent) => {
    navigate(`/admin/other-details/events/view/${item.id}`, {
      state: { item, mode: "view" },
    });
  };

  const handleEdit = (item: AdminEvent) => {
    navigate(`/admin/other-details/events/edit/${item.id}`, {
      state: { item, mode: "edit" },
    });
  };

  const handleDelete = async (id: number) => {
    try {
      const response: any = await deleteEvent({ id, plant }).unwrap();
      notifications.show({
        message: response?.message,
        color: "green",
        autoClose: 3000,
      });
    } catch (error: any) {
      notifications.show({
        message: error?.data?.message || "An error occurred",
        color: "red",
        autoClose: 5000,
      });
    }
  };

  const handleBulkDelete = async () => {
    if (selectedEventIds.length === 0) {
      return;
    }

    setDeleteModalOpen(true);
  };

  const confirmBulkDelete = async () => {
    setDeleteModalOpen(false);
    setIsBulkDeleting(true);

    try {
      const response: any = await bulkDeleteEvents({
        ids: selectedEventIds,
        plant,
      }).unwrap();

      notifications.show({
        message: response?.message,
        color: "green",
        autoClose: 3000,
      });

      setSelectedEventIds([]);
      refetch();
    } catch (error: any) {
      notifications.show({
        message: error?.data?.message || "An error occurred",
        color: "red",
        autoClose: 5000,
      });
    } finally {
      setIsBulkDeleting(false);
    }
  };

  const handleAdd = () => {
    navigate(`/admin/other-details/events/add`);
  };

  if (isLoading) {
    return (
      <Center style={{ height: "400px" }}>
        <Loader size="lg" />
      </Center>
    );
  }

  return (
    <div className="w-full max-w-full box-border overflow-x-hidden">
      <Modal
        opened={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        title="Delete Events"
        centered
      >
        <Text size="sm" mb="lg">
          Are you sure you want to delete selected event(s)? This action cannot be undone.
        </Text>

        <Group justify="flex-end" gap="sm">
          <Button variant="outline" onClick={() => setDeleteModalOpen(false)}>
            Cancel
          </Button>
          <Button
            color="red"
            onClick={confirmBulkDelete}
            loading={isBulkDeleting}
          >
            Delete event(s)
          </Button>
        </Group>
      </Modal>

    

<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5 mx-auto">
  <h3 className="text-base font-medium">Events</h3>

  <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
    
    
    {/* <button
      onClick={handleBulkDelete}
  
      disabled={isBulkDeleting || selectedEventIds.length === 0}
      className={`flex items-center justify-center w-10 h-10 rounded border transition-colors ${
        selectedEventIds.length > 0
          ? "bg-red-50 text-red-600 border-red-200 hover:bg-red-100" 
          : "bg-gray-50 text-gray-400 border-gray-200 cursor-not-allowed" 
      }`}
      title={selectedEventIds.length === 0 ? "Select items to delete" : "Delete Selected"}
    >
      <Trash2 size={18} />
    </button> */}

    <Input
      placeholder="Search by events name, description"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      leftSection={<Search size={16} />}
      className="w-full sm:w-[300px]"
    />

    <button
      onClick={handleAdd}
      className="bg-blue-600 text-white text-sm px-4 py-2 rounded shadow hover:bg-blue-700 whitespace-nowrap self-end sm:self-auto"
    >
      + Add Event
    </button>
  </div>
</div>
      <div className="bg-white p-4 sm:p-5 rounded shadow-sm w-full mx-auto min-h-[260px]">
        <EventsTable
          items={events}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onSelectionChange={setSelectedEventIds}
          onBulkDelete={handleBulkDelete}
         selectedCount={selectedEventIds.length}
        />
      </div>
    </div>
  );
};

export default AdminEvents;
